export class InvitationData {
    UserId?: number;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    TechnicianId?: number;
    OwnerId?: number;
    Verification?: string; // verification hash code for security check
    DeviceId?: number;
    RemotesMax?: number;
    SiteId?: number;

    constructor() {
    }
};

export const sharingOrTransferring = (invite: InvitationData): boolean => !!(invite.OwnerId && invite.Verification);

export const shareDeviceInvitation = (invite: InvitationData): boolean => !!(invite.DeviceId && (typeof invite.RemotesMax !== 'undefined'));

export const transferSiteInvitation = (invite: InvitationData): boolean => !!(invite.SiteId);

export const customerInvitation = (invite: InvitationData): boolean => !!(invite.TechnicianId && invite.Verification);
